// utils.js
const prefixNum = (num) => {
    if (parseInt(num) < 10) {
        return `0${num}`
    } else {
        return num
    }
}



const trim = (str) => {
    return str.replace(/(^\s*)|(\s*$)/g, ""); 
}
const getWheelDelta = (event) => {      // 判断滚轮滚动方向
    event = event || window.event
    if (event.wheelDelta) {
        return event.wheelDelta
    } else {        // 兼容火狐
        return -event.detail
    }
}

const getOrigin = (vue) => {
    console.log(vue.$route.query)
    return vue.$route.query.utm_source || ''
}

const debounce = (fn, delay, scope) => {        // 防抖函数
    let timer = null;
    return function () {
        let context = scope || this,
            args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}

const openWin = (url,name,iWidth,iHeight) => {      // 打开新窗口
    if(!name && !iWidth && !iHeight) {
        window.open(url)
    } else {
        //获得窗口的垂直位置 
        var iTop = (window.screen.availHeight - 30 - iHeight) / 2; 
        //获得窗口的水平位置 
        var iLeft = (window.screen.availWidth - 10 - iWidth) / 2; 
        window.open(url, name, 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no'); 
    }
}

const tweetShare = (channel, author, tid) => {     // 推文分享
    switch (channel) {
        case 'fb':
            openWin('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(`https://twitter.com/${author}/status/${tid}`))
            break;
        case 'tw': 
            openWin('https://twitter.com/intent/tweet?url=' + encodeURIComponent(`https://twitter.com/${author}/status/${tid}`) + `&via=${author}`)
            break;
        default:
            break;
    }
}

const formatTime = (time) => {
    let year = new Date(time).getFullYear()
    let month = new Date(time).getMonth() + 1
    let date = new Date(time).getDate()

    if(month < 10) {
        month = `0${month}`
    }
    if(date < 10) {
        date = `0${date}`
    }

    return `${year}.${month}.${date}`;
}

const getDomain = (url) => {
    let arrUrl = url.split("//")
    let pre = arrUrl[0]
    let start = arrUrl[1].indexOf("/")
    let relUrl = arrUrl[1].substring(start, 0)
    return `${pre}//${relUrl}`
}

export default {
    getOrigin,
    trim,
    getWheelDelta,
    debounce,
    openWin,
    tweetShare,
    formatTime,
    getDomain,
    prefixNum
}